import moment from '@utils/moment-wrapper';
import { i18n_t as $t, i18n_locale } from '@utils/i18n';
import { getActiveSubscription } from '@/data/session/session-globals.ts';

export default function timestampFormatter ({ timestamp, period, upperCase, dayOfWeek }) {
    const timeZone = getActiveSubscription()?.timeZone;

    let formattedTimestamp;
    const momentifiedX = moment(timestamp);
    switch (period) {
        case 'hourly': {
            const formatter = new Intl.DateTimeFormat(i18n_locale?.value, {
                month: 'long',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                hour12: true,
                timeZone,
            });
            const parts = formatter.formatToParts(timestamp);
            formattedTimestamp = parts
                .map((part) => {
                    if (part.type === 'literal') {
                        if (part.value.includes('at')) {
                            return ', ';
                        }
                    }

                    return part.value;
                })
                .join('');
            break;
        }
        case 'daily':
            formattedTimestamp = dayOfWeek ? momentifiedX.format('ddd, LL') : momentifiedX.format('LL');
            break;
        case 'weekly': {
            const nextWeek = moment(timestamp).add(6, 'd');
            const startDate = new Intl.DateTimeFormat(i18n_locale?.value, {
                month: 'long',
                day: 'numeric',
                timeZone,
            }).format(timestamp);

            formattedTimestamp = $t('customDateRange', {
                start: startDate,
                end: nextWeek.format('LL'),
            });
            break;
        }
        case 'monthly':
            formattedTimestamp = new Intl.DateTimeFormat(i18n_locale?.value, {
                year: 'numeric',
                month: 'long',
                timeZone,
            }).format(timestamp);
    }
    if (upperCase) formattedTimestamp = formattedTimestamp.toUpperCase();

    return formattedTimestamp;
}
